module.exports = __webpack_public_path__ + "media/images/products/template/01/09-7ed1671ff58063288258bae45d47c033.jpg";